
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/OwlCarousel.js';
import 'react-owl-carousel2/lib/styles.css';

export default function Testimonials() {

    const options = {
        items: 3,
        nav: true,
        dots:true,
        rewind: true,
        autoplay: true,
        loop: true,
        center:true,
        margin:10
    };
    
  return (
    <>
<section className='testimonial5 py-5 bg-inverse'>
    <div className='container'>
    <div className="row justify-content-center">
      <div className="col-md-7 text-center">
        <h6 className="subtitle font-weight-normal">Reviews on Us</h6>
        <h3 className="testimonial-title">Testimonials</h3>
      </div>
    </div>

    <div className='testi5 mt-4 text-center'>
<OwlCarousel options={options} >
    <div>
    <div className="content">
          <p>“It was incredibly refreshing to work with an agency that focused on
           our needs as business.”</p>
           <h6 className="client-name"><span>“</span> Erin Wilson</h6>
          </div>
          <div className="customer-thumb">
            <img src="https://www.wrappixel.com/demos/ui-kit/wrapkit/assets/images/testimonial/1.jpg" alt="wrapkit" className="rounded-circle" />
          </div>
    </div>
    <div>
    <div className="content">
          <p>“It was incredibly refreshing to work with an agency that focused on
           our needs as business.”</p>
           <h6 className="client-name"><span>“</span> Erin Wilson</h6>
          </div>
          <div className="customer-thumb">
            <img src="https://www.wrappixel.com/demos/ui-kit/wrapkit/assets/images/testimonial/1.jpg" alt="wrapkit" className="rounded-circle" />
          </div>
    </div>
    <div>
    <div className="content">
          <p>“It was incredibly refreshing to work with an agency that focused on
           our needs as business.”</p>
           <h6 className="client-name"><span>“</span> Erin Wilson</h6>
          </div>
          <div className="customer-thumb">
            <img src="https://www.wrappixel.com/demos/ui-kit/wrapkit/assets/images/testimonial/1.jpg" alt="wrapkit" className="rounded-circle" />
          </div>
    </div>
</OwlCarousel>
</div>
</div>
</section>
      
    </>
  )
}
